import { createSlice } from '@reduxjs/toolkit'

export const configSlice = createSlice({
    name: 'config',
    initialState: {
        base_url: process.env.REACT_APP_BASE_URL
        , api_url: process.env.REACT_APP_API_URL
        , socket_url: process.env.REACT_APP_SOCKET_URL
        , socket_url_path: process.env.REACT_APP_SOCKET_URL_PATH

        , auth: {
            basic: 'Basic c2tyaXBzaTpza3JpcHNpX2szNA=='
        }
        , caps: {}
    }
    , reducers: {

    }
});

export default configSlice.reducer;